export default {
  // list
  'bu_cost.column.orderId': 'orderId',
  'bu_cost.column.ladingOrderId': 'ladingOrderId',
  'bu_cost.column.transportOrderId': 'transportOrderId',
  'bu_cost.column.businessType': 'businessType',
  'bu_cost.column.costItemId': 'costItemId',
  'bu_cost.column.costItemName': 'costItemName',
  'bu_cost.column.ourCompanyId': 'ourCompanyId',
  'bu_cost.column.contractCompanyId': 'contractCompanyId',
  'bu_cost.column.costDate': 'costDate',
  'bu_cost.column.paymentDirection': 'paymentDirection',
  'bu_cost.column.qty': 'qty',
  'bu_cost.column.weight': 'weight',
  'bu_cost.column.unitPrice': 'unitPrice',
  'bu_cost.column.totalAmount': 'totalAmount',
  'bu_cost.column.unitPriceExclTax': 'unitPriceExclTax',
  'bu_cost.column.taxRate': 'taxRate%',
  'bu_cost.column.taxAmount': 'taxAmount',
  'bu_cost.column.totalAmountExclTax': 'totalAmountExclTax',
  'bu_cost.column.currencyCode': 'currencyCode',
  'bu_cost.column.settlementStatus': 'settlementStatus',
  'bu_cost.column.genBillStatus': 'genBillStatus',
  'bu_cost.column.rejectionReason': 'rejectionReason',
  'bu_cost.column.costBatchNo': 'costBatchNo',
  'bu_cost.column.applyStatus': 'applyStatus',
  'bu_cost.column.paymentStatus': 'paymentStatus',
  // edit
  'bu_cost.edit.title': 'Edit BuCost',
  'bu_cost.add.title': 'Add BuCost',
  'bu_cost.edit.success': 'Edit Successful',
  'bu_cost.add.success': 'Add Successful',
  'bu_cost.form.orderId.required': 'orderId cannot be null',
  'bu_cost.form.ladingOrderId.required': 'ladingOrderId cannot be null',
  'bu_cost.form.businessType.required': 'businessType cannot be null',
  'bu_cost.form.costItemId.required': 'costItemId cannot be null',
  'bu_cost.form.costItemName.required': 'costItemName cannot be null',
  'bu_cost.form.ourCompanyId.required': 'ourCompanyId cannot be null',
  'bu_cost.form.contractCompanyId.required': 'contractCompanyId cannot be null',
  'bu_cost.form.costDate.required': 'costDate cannot be null',
  'bu_cost.form.paymentDirection.required': 'paymentDirection cannot be null',
  'bu_cost.form.qty.required': 'qty cannot be null',
  'bu_cost.form.totalAmount.required': 'totalAmount cannot be null',
  'bu_cost.form.unitPriceExclTax.required': 'unitPriceExclTax cannot be null',
  'bu_cost.form.taxRate.required': 'taxRate cannot be null',
  'bu_cost.form.taxAmount.required': 'taxAmount cannot be null',
  'bu_cost.form.totalAmountExclTax.required': 'totalAmountExclTax cannot be null',
  'bu_cost.form.currencyCode.required': 'currencyCode cannot be null',
  'bu_cost.form.settlementStatus.required': 'settlementStatus cannot be null',
  'bu_cost.form.genBillStatus.required': 'genBillStatus cannot be null',
  'bu_cost.form.costBatchNo.required': 'costBatchNo cannot be null',
  'bu_cost.form.applyStatus.required': 'applyStatus cannot be null',
  'bu_cost.form.paymentStatus.required': 'paymentStatus cannot be null',
  'bu_cost.form.orderId': 'orderId',
  'bu_cost.form.orderId.placeholder': 'Enter orderId',
  'bu_cost.form.ladingOrderId': 'ladingOrderId',
  'bu_cost.form.ladingOrderId.placeholder': 'Enter ladingOrderId',
  'bu_cost.form.transportOrderId': 'transportOrderId',
  'bu_cost.form.transportOrderId.placeholder': 'Enter transportOrderId',
  'bu_cost.form.businessType': 'businessType',
  'bu_cost.form.businessType.placeholder': 'Enter businessType',
  'bu_cost.form.costItemId': 'costItemId',
  'bu_cost.form.costItemId.placeholder': 'Enter costItemId',
  'bu_cost.form.costItemName': 'costItemName',
  'bu_cost.form.costItemName.placeholder': 'Enter costItemName',
  'bu_cost.form.ourCompanyId': 'ourCompanyId',
  'bu_cost.form.ourCompanyId.placeholder': 'Enter ourCompanyId',
  'bu_cost.form.contractCompanyId': 'contractCompanyId',
  'bu_cost.form.contractCompanyId.placeholder': 'Enter contractCompanyId',
  'bu_cost.form.costDate': 'costDate',
  'bu_cost.form.costDate.placeholder': 'Enter costDate',
  'bu_cost.form.paymentDirection': 'paymentDirection',
  'bu_cost.form.paymentDirection.placeholder': 'Enter paymentDirection',
  'bu_cost.form.qty': 'qty',
  'bu_cost.form.qty.placeholder': 'Enter qty',
  'bu_cost.form.weight': 'weight',
  'bu_cost.form.weight.placeholder': 'Enter weight',
  'bu_cost.form.unitPrice': 'unitPrice',
  'bu_cost.form.unitPrice.placeholder': 'Enter unitPrice',
  'bu_cost.form.totalAmount': 'totalAmount',
  'bu_cost.form.totalAmount.placeholder': 'Enter totalAmount',
  'bu_cost.form.unitPriceExclTax': 'unitPriceExclTax',
  'bu_cost.form.unitPriceExclTax.placeholder': 'Enter unitPriceExclTax',
  'bu_cost.form.taxRate': 'taxRate',
  'bu_cost.form.taxRate.placeholder': 'Enter taxRate',
  'bu_cost.form.taxAmount': 'taxAmount',
  'bu_cost.form.taxAmount.placeholder': 'Enter taxAmount',
  'bu_cost.form.totalAmountExclTax': 'totalAmountExclTax',
  'bu_cost.form.totalAmountExclTax.placeholder': 'Enter totalAmountExclTax',
  'bu_cost.form.currencyCode': 'currencyCode',
  'bu_cost.form.currencyCode.placeholder': 'Enter currencyCode',
  'bu_cost.form.settlementStatus': 'settlementStatus',
  'bu_cost.form.settlementStatus.placeholder': 'Enter settlementStatus',
  'bu_cost.form.genBillStatus': 'genBillStatus',
  'bu_cost.form.genBillStatus.placeholder': 'Enter genBillStatus',
  'bu_cost.form.rejectionReason': 'rejectionReason',
  'bu_cost.form.rejectionReason.placeholder': 'Enter rejectionReason',
  'bu_cost.form.costBatchNo': 'costBatchNo',
  'bu_cost.form.costBatchNo.placeholder': 'Enter costBatchNo',
  'bu_cost.form.applyStatus': 'applyStatus',
  'bu_cost.form.applyStatus.placeholder': 'Enter applyStatus',
  'bu_cost.form.paymentStatus': 'paymentStatus',
  'bu_cost.form.paymentStatus.placeholder': 'Enter paymentStatus',
}
